import React from 'react';
import { NavLink, withRouter } from 'react-router-dom'
import { connect } from 'react-redux';

import { fetchProfiles } from '../../actions/profiles';

import SideBarNavigationLink from '../layout/SideBarNavigationLink';
import Loading from '../layout/Loading';

import styles from './list.scss';

import { Icon } from '../icons';

const List = ({ profiles, activeProfileId, loading }) => {
  // if(loading)
  //   return <Loading>Loading profiles</Loading>

  return (
    <div>
      {loading && <Loading text="Loading profiles"></Loading>}
      <ul className="profile-list">
        {profiles.map(profile =>
          <SideBarNavigationLink key={profile.id} to={`/organisations/${profile.organisation_id}/profiles/${profile.id}`} active ={activeProfileId === profile.id}>
            <Icon type={profile.multi ? 'profiles' : 'profile'} className="profile-icon"/>
            <div className="profile-name">{profile.name}</div>
            <span className="profile-counter">{profile.device_count}</span>
          </SideBarNavigationLink>
        )}
      </ul>
    </div>
  )
}

export default List;



// WEBPACK FOOTER //
// ./src/components/profiles/List.js